import { IOptionGroupPayload } from 'src/api/updateModifierGroup/types';
import { IOptionGroupItem, IOptionGroupValues } from '../../types';
import { EntitySource } from 'src/constants';

const formatCreateOptionGroupRequest = (data: IOptionGroupValues): IOptionGroupPayload => {
  return {
    pk_modifier_group_id: data.optionGroupId,
    name: data.name,
    consumer_name: data.consumer_name,
    description: data.description,
    min_choices: data.min_choices,
    max_choices: data.max_choices,
    is_repeatable: !data.uniqueOnly,
    ranges: data.source === EntitySource.RANGES && data.ranges ? data.ranges : [],
    modifiers: data.modifiers.map((modifier: IOptionGroupItem) => {
      return {
        item_id: modifier.parentItemId || modifier.optionItemId,
        plu: modifier.inheritPosId ? null : modifier.posId || null,
        value_with_tax: modifier.useDefaultPrice ? null : modifier.valueWithTax,
      };
    }),
    external_systems: data.externalSystems,
  };
};

export default formatCreateOptionGroupRequest;
